import {
  Alert,
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormHelperText,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Switch,
  TextField,
  Typography,
  IconButton,
  Radio,
  RadioGroup,
  Tooltip,
  FormLabel,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import {
  BUTTON_STYLES,
  FORM_STYLES,
  MODAL_STYLES,
  TEXT_FIELD_STYLES,
} from "../../styles/componentStyles";
import { useFormik } from "formik";
import api from "../../axiosInstance";
import { toast } from "react-toastify";
import StatesValidationSchema from "../Validations/AcademicsValidation";
import Staets from "./States";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadFileIcon from "@mui/icons-material/UploadFile";

function CoursesModal({ States, open, onClose, coursesEdit, onSuccess }) {
  const [categories, setCategories] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [universities, setUniversity] = useState([]);
  const [courses, setCourses] = useState([]);
  const [coursesImage, setCoursesImage] = useState(null);
  const [imageError, setImageError] = useState(null);
  console.log(coursesEdit);

  // Fetch dropdown data once
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const universitiesRes = await api.get("/getAllUniversities");
        setUniversity(universitiesRes.data.data);
        const allCourse = await api.get("/getCourses");
        setCourses(allCourse.data.data);
      } catch (err) {
        const message =
          err.response?.data?.message ||
          err.message ||
          "Something went wrong while fetching dropdown data";
        setError(message);
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchDropdownData();
  }, []);

  //  Form vlaidation using useFormik hook
  const formik = useFormik({
    initialValues: {
      courseName: coursesEdit?.courseName || "",
      courseCode: coursesEdit?.courseCode || "",
      image: coursesEdit?.image || "",
      description: coursesEdit?.description || "",
      credits: coursesEdit?.credits || "",
      universityId: coursesEdit?.universityId || "",
      noOfSemester: coursesEdit?.noOfSemester || "",
      // String(): the selects' values are "true"/"false"; ?? keeps a real false (|| turned it into "true")
      active: String(coursesEdit?.active ?? true),
      viewable: String(coursesEdit?.viewable ?? false),
      semesters: coursesEdit?.semesters || [],
      category: coursesEdit?.category || "",
      paymentType: coursesEdit?.payment?.id || "",
      courseExtension: coursesEdit?.courseExtension || "",
      mentorshipEnable: String(coursesEdit?.mentorshipEnable ?? true),
    },

    validationSchema: StatesValidationSchema.courseValidationSchema(
      courses,
      coursesEdit?.id,
    ),
    enableReinitialize: true,

    onSubmit: async (values, { resetForm, setSubmitting }) => {
      console.log("hello");
      try {
        setSubmitting(true);
        let response;
        // If it's Edit data it will call Update api
        if (coursesEdit?.id) {
          response = await api.put(`/api/courses/${coursesEdit?.id}`, values);
        }

        // Else it's Add data it will call Add api
        else {
          response = await api.post("/api/courses", values);
        }
        // Show success toast
        toast.success(
          `Course ${coursesEdit?.id ? "updated" : "added"} successfully!`,
          {
            position: "top-right",
            autoClose: 2000,
          },
        );
        onSuccess(response.data.data);
        resetForm();
        onClose();
      } catch (error) {
        toast.error("Failed to submit. Please try again.", {
          autoClose: 3000,
        });
        console.error("API Error:", error);
      } finally {
        setSubmitting(false);
      }
    },
  });
  // COurse image upload in FTP
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [loadingImage, setLoadingImage] = useState(false);
  const [coursesType, setCoursesType] = useState("upload");
  const [imagesUrl, setImagesUrl] = useState([]);
  const [deletingImage, setDeletingImage] = useState(false);

  const handleIconClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setImageError("");
      console.log("File selected:", file.name);
    }
  };
  const handleUploadClick = async () => {
    if (!selectedFile) {
      console.log("No file selected!");
      return;
    }
    setLoadingImage(true);
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await api.post("/api/ftp/uploadCourseImage", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setCoursesImage(response.data.path);
      formik.setFieldValue("image", response.data.path);
      console.log("Upload success:", response.data);
      setLoadingImage(false);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 409) {
          setImageError(error.response.data.errorMessage);
          setLoadingImage(false);
        }
        console.error("Server responded with error:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up request:", error.message);
      }
    }
  };
  // Delete upload image record api fetch data
  const handleDelete = async () => {
    setDeletingImage(true);
    setLoadingImage(false);
    setImageError(false);
    try {
      await api.put(`/api/ftp/delete`, { path: coursesImage });
      setCoursesImage("");
      setDeletingImage(false);
      formik.setFieldValue("image", "");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (error) {
      console.error("Delete failed:", error);
      if (error.response.status === 400) {
        setImageError(error.response.data.errorMessage);
      }
    } finally {
      setDeletingImage(false);
    }
  };
  // Get iamge url api
  useEffect(() => {
    api
      .get("/api/ftp/getCourses")
      .then((response) => {
        setImagesUrl(response.data.files);
      })
      .catch((error) => {
        console.log("Error fecthing get api", error);
      })
      .finally(() => setLoadingImage(false));
  }, []);
  // Updating coursesType state
  useEffect(() => {
    if (coursesEdit && Object.keys(coursesEdit).length > 0) {
      setCoursesType("select");
    } else {
      setCoursesType("upload");
    }
  }, [coursesEdit]);
  return (
    <>
      {/* Loading State */}
      {isLoading && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}
      <Modal open={open} onClose={onClose} disableScrollLock>
        <Box
          sx={{ ...MODAL_STYLES.standard, width: { xs: 340, md: 500 } }}
          component="form"
          onSubmit={formik.handleSubmit}
        >
          <Typography
            variant="h5"
            component="h2"
            sx={{ mb: 3, fontWeight: 600 }}
          >
            {coursesEdit && Object.keys(coursesEdit).length > 0
              ? "Update Course"
              : "Add Course"}
          </Typography>
          <Box sx={FORM_STYLES.container}>
            <TextField
              label="Course Name"
              name="courseName"
              value={formik.values.courseName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.courseName && Boolean(formik.errors.courseName)
              }
              helperText={formik.touched.courseName && formik.errors.courseName}
              {...TEXT_FIELD_STYLES.standard}
            />
            <TextField
              label="Course Code"
              name="courseCode"
              value={formik.values.courseCode}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.courseCode && Boolean(formik.errors.courseCode)
              }
              helperText={formik.touched.courseCode && formik.errors.courseCode}
              {...TEXT_FIELD_STYLES.standard}
            />
            <TextField
              multiline
              label="Description"
              name="description"
              rows={3}
              value={formik.values.description}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.description && Boolean(formik.errors.description)
              }
              helperText={
                formik.touched.description && formik.errors.description
              }
              {...TEXT_FIELD_STYLES.standard}
            />
            <TextField
              label="Credits"
              name="credits"
              value={formik.values.credits}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.credits && Boolean(formik.errors.credits)}
              helperText={formik.touched.credits && formik.errors.credits}
              {...TEXT_FIELD_STYLES.standard}
            />
            <TextField
              label="Category"
              name="category"
              value={formik.values.category}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.category && Boolean(formik.errors.category)}
              helperText={formik.touched.category && formik.errors.category}
              {...TEXT_FIELD_STYLES.standard}
            />

            <FormControl
              fullWidth
              error={
                formik.touched.universityId &&
                Boolean(formik.errors.universityId)
              }
            >
              <InputLabel>University</InputLabel>
              <Select
                name="universityId"
                value={formik.values.universityId}
                onChange={formik.handleChange}
                label="university"
                onBlur={formik.handleBlur}
                error={
                  formik.touched.universityId &&
                  Boolean(formik.errors.universityId)
                }
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 400,
                    },
                  },
                }}
              >
                {universities.map((u) => (
                  <MenuItem key={u.id} value={u.id}>
                    {u.name}
                  </MenuItem>
                ))}
              </Select>
              {formik.touched.universityId && formik.errors.universityId && (
                <FormHelperText sx={{ color: "red" }}>
                  {formik.errors.universityId}
                </FormHelperText>
              )}
            </FormControl>
            <FormControl>
              <FormLabel
                component="legend"
                sx={{ color: "#66667f !important", fontWeight: 450 }}
              >
                Select Courses Image Type
              </FormLabel>

              <RadioGroup
                row
                aria-labelledby="demo-form-control-label-placement"
                name="position"
                value={coursesType}
                onChange={(e) => setCoursesType(e.target.value)}
              >
                <FormControlLabel
                  value="upload"
                  control={<Radio />}
                  label="Upload Image"
                />
                <FormControlLabel
                  value="select"
                  control={<Radio />}
                  label="Select Image"
                />
              </RadioGroup>
            </FormControl>
            {coursesType == "upload" ? (
              <>
                <Box sx={{ display: "flex", gap: 1, marginTop: "10px" }}>
                  <TextField
                    fullWidth
                    size="small"
                    type="file"
                    name="image"
                    inputRef={fileInputRef}
                    inputProps={{ accept: "image/*" }}
                    onChange={handleFileChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.image && Boolean(formik.errors.image)}
                  />

                  <Tooltip title="Upload image" arrow placement="top">
                    <IconButton
                      color="primary"
                      onClick={handleUploadClick}
                      size="small"
                      sx={{}}
                    >
                      <UploadFileIcon style={{ cursor: "pointer" }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Delete image" arrow placement="top">
                    <IconButton
                      color="error"
                      onClick={() => handleDelete()}
                      size="small"
                      sx={{}}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
                {/* SHOW NOTE ONLY WHEN NO MESSAGES ARE ACTIVE */}
                {!loadingImage &&
                  !deletingImage &&
                  !imageError &&
                  !coursesImage && (
                    <Typography
                      sx={{
                        color: "#66667f",
                        fontSize: "13px",
                        fontStyle: "italic",
                      }}
                    >
                      Note: After clicking the upload button, wait until the
                      image URL appears.
                    </Typography>
                  )}

                {/* ERROR OR STATUS MESSAGES */}
                {imageError ? (
                  <Typography
                    sx={{
                      color: "red",
                      fontSize: "14px",
                    }}
                  >
                    {imageError}
                  </Typography>
                ) : (
                  <Typography
                    sx={{
                      color: "#66667f",
                      fontSize: "13px",
                      fontStyle: "italic",
                    }}
                  >
                    {loadingImage && " ...Uploading Image"}
                    {deletingImage && " ...Deleting Image"}
                    {!loadingImage && !deletingImage && coursesImage && (
                      <>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Typography sx={{ fontSize: "13px", color: "#666" }}>
                            Image Url: {coursesImage}
                          </Typography>

                          <Box
                            component="img"
                            src={`https://siaedutech.com/public/${coursesImage}`}
                            alt="preview"
                            sx={{
                              width: "70px",
                              borderRadius: 1,
                              border: "1px solid #ddd",
                              ml: 1,
                            }}
                          />
                        </Box>
                      </>
                    )}
                  </Typography>
                )}
              </>
            ) : (
              <FormControl
                size="small"
                fullWidth
                error={formik.touched.active && Boolean(formik.errors.active)}
                sx={{ mt: 2 }}
              >
                <InputLabel>Image URL</InputLabel>
                <Select
                  label="Image URL"
                  labelId="image-select-label"
                  id="image"
                  name="image"
                  value={formik.values.image}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.image && Boolean(formik.errors.image)}
                  helperText={formik.touched.image && formik.errors.image}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: "400px",
                        overflowY: "auto",
                      },
                    },
                  }}
                  sx={{
                    "& .MuiSelect-select": {
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    },
                  }}
                >
                  {imagesUrl.map((img, index) => (
                    <MenuItem
                      value={img}
                      key={index}
                      sx={{
                        "& .MuiSelect-select": {
                          display: "flex",
                          alignItems: "center",
                          gap: 2,
                        },
                      }}
                    >
                      <Box
                        component="img"
                        src={`https://siaedutech.com/public/${img}`}
                        alt="preview"
                        sx={{
                          width: "100px",
                          borderRadius: 1,
                          border: "1px solid #ddd",
                        }}
                      />{" "}
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: "#555",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {img}
                      </Typography>
                    </MenuItem>
                  ))}
                </Select>

                {formik.touched.image && formik.errors.image && (
                  <FormHelperText sx={{ color: "red" }}>
                    {formik.errors.image}
                  </FormHelperText>
                )}
              </FormControl>
            )}
            <TextField
              label="Image Url"
              name="image"
              value={formik.values.image}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.image && Boolean(formik.errors.image)}
              helperText={formik.touched.image && formik.errors.image}
              {...TEXT_FIELD_STYLES.standard}
            />
            <TextField
              label="No.Of Semester"
              name="noOfSemester"
              value={formik.values.noOfSemester}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.noOfSemester &&
                Boolean(formik.errors.noOfSemester)
              }
              helperText={
                formik.touched.noOfSemester && formik.errors.noOfSemester
              }
              {...TEXT_FIELD_STYLES.standard}
            />
            <FormControl
              fullWidth
              error={
                formik.touched.semesters && Boolean(formik.errors.semesters)
              }
              sx={{ mt: 2 }}
            >
              <InputLabel id="semesters-label">Semesters</InputLabel>
              <Select
                multiple
                labelId="semesters-label"
                id="semesters"
                name="semesters"
                value={
                  formik.values.semesters && formik.values.semesters.length > 0
                    ? formik.values.semesters
                    : []
                }
                onChange={(e) => {
                  const values = e.target.value;
                  formik.setFieldValue(
                    "semesters",
                    Array.isArray(values) ? values.map((v) => Number(v)) : [],
                  );
                }}
                onBlur={formik.handleBlur}
                label="semesters"
              >
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((sem) => (
                  <MenuItem key={sem} value={sem}>
                    {sem}
                  </MenuItem>
                ))}
              </Select>
              {formik.touched.semesters && formik.errors.semesters && (
                <FormHelperText>{formik.errors.semesters}</FormHelperText>
              )}
            </FormControl>
            <FormControl
              fullWidth
              error={
                formik.touched.paymentType && Boolean(formik.errors.paymentType)
              }
              sx={{ mt: 2 }}
            >
              <InputLabel id="paymentType-label">Payment Type</InputLabel>
              <Select
                labelId="paymentType-label"
                id="paymentType"
                name="paymentType"
                value={formik.values.paymentType}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Payment Type"
              >
                <MenuItem value="1">SUBSCRIPTION</MenuItem>
                <MenuItem value="2">CART</MenuItem>
              </Select>
              {formik.touched.paymentType && formik.errors.paymentType && (
                <FormHelperText>{formik.errors.paymentType}</FormHelperText>
              )}
            </FormControl>
            <FormControl
              fullWidth
              error={formik.touched.active && Boolean(formik.errors.active)}
              sx={{ mt: 2 }}
            >
              <InputLabel id="active-label">Active</InputLabel>
              <Select
                labelId="active-label"
                id="active"
                name="active"
                value={formik.values.active}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Active"
              >
                <MenuItem value="true">Yes</MenuItem>
                <MenuItem value="false">No</MenuItem>
              </Select>
              {formik.touched.active && formik.errors.active && (
                <FormHelperText>{formik.errors.active}</FormHelperText>
              )}
            </FormControl>
            <FormControl
              fullWidth
              error={formik.touched.active && Boolean(formik.errors.active)}
              sx={{ mt: 2 }}
            >
              <InputLabel id="active-label">Viewable</InputLabel>
              <Select
                labelId="active-label"
                id="viewable"
                name="viewable"
                value={formik.values.viewable}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="viewable"
              >
                <MenuItem value="true">Yes</MenuItem>
                <MenuItem value="false">No</MenuItem>
              </Select>
              {formik.touched.viewable && formik.errors.viewable && (
                <FormHelperText>{formik.errors.viewable}</FormHelperText>
              )}
            </FormControl>

            <TextField
              label="Course Extension"
              name="courseExtension"
              value={formik.values.courseExtension}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.courseExtension && Boolean(formik.errors.courseExtension)}
              helperText={formik.touched.courseExtension && formik.errors.courseExtension}
              {...TEXT_FIELD_STYLES.standard}
            />

            <FormControl
              fullWidth
              error={formik.touched.mentorshipEnable && Boolean(formik.errors.mentorshipEnable)}
              sx={{ mt: 2 }}
            >
              <InputLabel id="mentorshipEnable-label">Mentorship Enable</InputLabel>
              <Select
                labelId="mentorshipEnable-label"
                name="mentorshipEnable"
                value={formik.values.mentorshipEnable}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                label="Mentorship Enable"
              >
                <MenuItem value="true">Yes</MenuItem>
                <MenuItem value="false">No</MenuItem>
              </Select>
              {formik.touched.mentorshipEnable && formik.errors.mentorshipEnable && (
                <FormHelperText>{formik.errors.mentorshipEnable}</FormHelperText>
              )}
            </FormControl>

            <Box
              sx={FORM_STYLES.actions}
              style={{
                display: "flex",
                marginTop: "20px",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <Button onClick={onClose} {...BUTTON_STYLES.secondary}>
                Cancel
              </Button>
              <Button
                type="submit"
                disabled={formik.isSubmitting}
                {...BUTTON_STYLES.primary}
              >
                {formik.isSubmitting ? "Processing..." : "Save"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default CoursesModal;
